import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import exceptions from "../../assets/exceptions.png";
import exceptionList from "../../assets/exceptionList.png";
import exceptionDetail from "../../assets/exceptionDetail.png";

export default function Exceptions() {
    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Exceptions</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Enlil enables the ability to view the details of any exception thrown within a tenant. To access the exception management screen, follow the procedure below.</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Login to developer.enlil.io using a valid enlil username/password.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Navigate to the Dashboard section.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Navigate to the Exception Management section
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Exceptions are presented in chronologically descending order.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Double click on any row to see the contents of the exception.
                </li>
                <br/><br/>
                <img alt="Exception Management" src={exceptions} style={{objectFit: "contain", width: "1000px"}}/>
                <br/><br/>
                <img alt="Exception List" src={exceptionList} style={{objectFit: "contain", width: "1000px"}}/>
                <br/><br/>
                <img alt="Exception Detail" src={exceptionDetail} style={{objectFit: "contain", width: "1000px"}}/>
            </ul>
        </div>
    )
}